import { clientMount } from '@vp/ubik-fragment-react';
import type { MountWithRootOptions } from '@vp/ubik-fragment-types';

import { Fragment, IRenderProps } from '../components/FragmentComponent';

export const mount: MountWithRootOptions<IRenderProps> = async (
  rootElement,
  renderProps,
  rootOptions
) => {
  return clientMount(<Fragment {...renderProps} />, rootElement, rootOptions);
};
